<!--libs\components\inputs\src\lib\ui-input-switch\ui-input-switch.component.html-->
<label
  class="ui-input-switch"
  [class.ui-input-switch--checked]="isChecked"
  [class.ui-input-switch--disabled]="disabled"
>
  <span class="ui-input-switch__main">
    <input
      class="ui-input-switch__native"
      [id]="id"
      type="checkbox"
      [formControl]="formControl!"
      [disabled]="disabled"
      (change)="onChange($event)"
    />

    <span class="ui-input-switch__track" aria-hidden="true">
      <span class="ui-input-switch__thumb"></span>
    </span>
  </span>

  <span class="ui-input-switch__content">
    @if (legend) {
      <span class="ui-input-switch__legend">{{ legend }}</span>
    }

    @if (label) {
      <span class="ui-input-switch__label">{{ label }}</span>
    }

    @if (description) {
      <span class="ui-input-switch__description">{{ description }}</span>
    }
  </span>
</label>